// extracted by mini-css-extract-plugin
export default {"offersListSkeletonItem":"offersListSkeletonItem_UsCtX","poster":"poster_P8P8H","text":"text_ra71D"};